import internal from "stream";
import { FeedstockLoadScheduleWithAdditionalStreamsByIdResponse } from "./feedStockLoadAdditionalRevenue";
import { FeedStockLoadAddDocumentRequest } from "./sitelockcodes";
import { LoadScheduleControlFlags } from "./securityPermissions";
import { RPCTypesTableType } from "./lookup";

export interface FeedstockLoadScheduleResponse {
  id: number;
  siteID: string;
  scheduleDate: string;
  workOrderNumber: string;
  feedstockStreamId: string;
  streamName: string;
  actualDate: string;
  actual_Quantity: number | null;
  actual_Volume_Tons: number | null;
  schedulingNotes: string;
  notesForCustomer: string;
  generatorId: string;
  generator: string;
  haulerId: string;
  hauler: string;
  ticket_Number: string;
  trailer_Number: string;
  biology_Notes: string;
  tankId: number;
  tankName: string;
  driver: string;
  loadSlip: boolean;
  projected_Quantity: number|null;
  haul_Rate_Perload: number| null;
  rebateValue: number | null
  status: number;
  statusDescription: string;
  originalStatusDescription: string;
  dispatchOverride: string;
  cOD_Required: boolean;
  unitOfMeasure: number;
  notesForHauler: string;
  notesForDisposalSite: string;
  truckType: number;
  truckTypeName: string;
  unitOfMeasure1: number;
  unitOfMeasureName: string;
  dispatch: boolean;
  feeCategory: number;
  feeCategoryName: string;
  isRebateEligible: boolean;
  rebateUOM: number;
  rebateQty: number | null;
  revenueRecord: boolean;
  flatFee: number;
  sampleStatus: string;
  sampleStatusDescription: string;
  sampleStatusToolTip: string;
  scheduleDayOfWeek: string;
  materialType: string;
  pickupLocation: string;
  createdBy: string;
  createdByName: string;
  actual_Volume_Gallons: number;
  internalNotes: string;
  loadSlipNumber: number;
  feeCategories: string;
  customerReferenceNo: string;
  adsFlag: boolean;
  market: number;
  cancelReasonId: number;
  cancelReasonNotes: string;
  cancelReasonName: string;
  cancelType: number;
  canDispatch: boolean;
  metalStatus: string | null; // e.g., "Fail"
  screenType: number;
  codNotes: string;
  disposalMethodId: number | null;
  isSelected: boolean;
  statusId: number;
  isEditingStatus: boolean;
  siteName: string;
  holdLoadOnComplete: boolean | null;
  menuData?: FeedStockLoadInfoResponse;
  seal: string | null;
  bol: string | null;
  truck_Number: string | null;
  isInvoiceReqForCancelledLoad: boolean | null;
  internalSiteHaulCostReason: number | null;
  tipFee: number | null;
  priceMatrixId: number | null;
  divertedLoad: boolean| null;
  scWorkOrderNo: number | null;
  haulingExpense: number | null;
}

export interface FeedstockLoadScheduleByIdResponse extends FeedstockLoadScheduleResponse {

}

export interface FSLoadStatus {
  loadScheduleId: number;
  status: number;
}
export interface UpdateFeedStockSampleStatusRequest {
  feedStockLoadScheduleId: number;
  sampleStatus: string;
  testingTypes: string| null;
}
export interface DispatchLoads {
  fsLoadScheduleId: number;
}
export interface FeedStockDispatchDetails extends DispatchLoads {

}
export interface DeliverRequest {
  dispatchIds: string[];
  schedulerType: string;
}
export interface FeedStockLoadInfoResponse {
  additionalRevenueRecordsCount: number;
  isInvoiced: number;
  attachmentCount: number;
  hasAdditionalStreams: number;
  revenueRecord: number; // Flag for 'Additional Info' color
  dispatch: number;      // Flag for 'Dispatch Info' color
  loadSlip: number;      // Flag for 'View Docs' enable/disable
  statusDescription: string;
  sampleStatus: string;
}

export interface FeedstockListRequest {
  marketIds?: string | null;
  genIds?: string | null;
  streamIds?: string | null;
  siteIds?: string | null;
  fromDate: string | null;
  toDate: string | null;
  scheduleTypeId: number;
  statusId: number;
}

export interface DeepackListRequest {
  marketId: number;
  siteId: number;
  fromDate: string | null;
  toDate: string | null;
  statusId: number;
  loadType: string,
  loadDirection: string
}
export interface GetDeepackOutboundRequest{
  siteID: string;
  fromDate: string;
  toDate: string;
  status: number | null;
  direction: number | null;
  loadType: number | null;
}

export interface GetDeepackOutboundResponse {
  id: number | null;
  shipFrom: string;
  generator: string;
  shipTo: string;
  status: string | null;
  siteName: string | null;
  date: Date | null;
  bol: string;
  workOrderNumber: string;
  carrierName: string;
  driver: string;
  truckNo: string;
  trailerNo: string;
  tankerNo: string;
  purchaseOrderNo: string;
  seal: string;
  release: string;
  cbD_PH: number | null;
  notes: string;
  direction: boolean;
  destination: string | null;
  location: string | null;
  loadSlip: boolean | null;
  revenueRecord: boolean | null;
  source: string | null;
  loadType: string | null;
  weightConfirmationYN: string | null;
  streams: DeepackOutboundStreamsTableType[];
}

export interface GetDeepackOutboundByIdResponse {
  id: number | null;
  shipFrom: string;
  generator: string;
  shipTo: string;
  status: string | null;
  siteName: string | null;
  generatorId: number | null;
  feedstockStreamId: number | null;
  haulerId: string | null;
  siteId: string | null;
  date: Date | null;
  bol: string;
  workOrderNumber: string;
  carrierName: string;
  driver: string;
  truckNo: string;
  trailerNo: string;
  tankerNo: string;
  purchaseOrderNo: string;
  seal: string;
  release: string;
  cbd_ph: number | null;
  notes: string;
  direction: boolean;
  destination: string | null;
  location: string | null;
  loadSlip: boolean | null;
  revenueRecord: boolean | null;
  source: string | null;
  loadType: string | null;
}

export interface DeepackOutboundStreamsTableType{
  id: number;
  fsLoadID: number;
  streamID: number;
  streamName: string;
  uom: number | null;
  quantity: number | null;
  cBD_WT: number| null;
  cBD_UOM: number | null;
  cUST_WT: number| null;
  cUST_UOM: number | null;
  actualTons: number | null;
  unitPrice: number | null;
}
export interface UpdateFSInternalNotesRequest {
  id: number;
  internalNotes: string;
  scheduleType: number;
}

export interface NotesInput {
  title: string;
  ipData: FeedstockLoadScheduleWithAdditionalStreamsByIdResponse;
  workorderno: string;
  scheduleTypeId: number;
}

export interface SaveFeedstockLoadScheduleRequest {
  id: number;
  siteID: string;
  scheduleDate: string;
  feedstockStreamId: string;
  tankId: number | null;
  projected_Quantity: number | null;
  actualDate: string | null;
  actual_Quantity: number | null;
  actual_Volume_Tons: number | null;
  schedulingNotes: string | null;
  notesForCustomer: string | null;
  internalNotes: string | null;
  haulerId: string;
  generatorId: string;
  streamId: number;
  hauler: string;
  driver: string;
  ticket_Number: string;
  trailer_Number: string | null;
  biology_Notes: string;
  status: string;
  dispatchOverride: string;
  cOD_Required: boolean;
  unitOfMeasure: number | null;
  scheduleType: number | null;
  notesForHauler: string | null;
  notesForDisposalSite: string | null;
  truckType: number | null;
  feeCategory: number | null;
  rebateUOM: number | null;
  rebateQty: number | null;
  tipFee: number | null;
  flatFee: number | null;
  loadSlipNumber: number | null;
  feeCategories: string | null;
  customerReferenceNo: string | null;
  cancelReasonId: number | null;
  cancelReasonNotes: string | null;
  codNotes: string | null;
  holdLoadOnComplete: boolean | null;
  disposalMethodId: number | null;
  internalSiteHaulCostReason: number | null;
  seal: string | null;
  bol: string | null;
  truck_Number: string | null;
  isInvoiceReqForCancelledLoad: boolean | null;
  priceMatrixId: number | null;
  divertedLoad: boolean| null;
  scWorkOrderNo: Number| null;
  haulingExpense: number | null;
  fS_LoadSchedule_AdditionalStreams: SaveFeedStockLoadSchedule_AdditionalStreamsRequest[];
  rpcTypesWithCount: RPCTypesTableType[]
}

export interface SaveFeedStockLoadSchedule_AdditionalStreamsRequest {
  id: string;
  fSLoadID: number;
  streamID: number;
  streamName: string;
  uom: number;
  uOMText: string;
  quantity: number;
  tons: number | null;
  aPriceMatrixId: number | null;
}

export interface FeedstockLoadScheduleData {

  id?: number | null;
  task: string;
  workOrderNumber?: string;
  tankId?: string | null;
  stid?: string | null;
  siteTypeId?: string | null;
  marketId?: string | null;
  showPopupSaveButton?: boolean;

  generatorId: number | null;

  streamId: number | null;
  disposalSiteId: string | null;
  haulerId: number | null;
  uomId: number | null;
  projectedQuantity: number | null;
  actualDate: Date | null;
  tipFee: number | null;
  feeCategoryId: number | null;
  haulRevenue: number | null;
  flatFee: number | null;
  statusId: number | null;
  actualQuantity: number | null;
  driverName: string | '';
  loadSlipNumber: string | '';
  trailerNumber: string | '';
  customerReferenceNo: string | '';
  internalNotes: string | '';
  notesForHauler: string | '';
  notesForCustomer: string | '';
  codNotes: string | '';
  holdLoadOnComplete: boolean | null;
  additionalStreams?: FeedStockLoadSchedule_AdditionalStreams[];
}

export interface FeedStockLoadSchedule_AdditionalStreams {
  id: number | 0;
  fsLoadID: number | 0;
  uom: string;
  uomText: string;
  streamName: string;
  streamId: string;
  quantity: number | 0;
}

export interface DropdownOption {
  id: number | string;
  name: string;
}

export interface LoadSchedulePopupInput {
  task: string | "Add";
  screenName: string | "AD";
  fsLoadId: number | 0;
  marketId: string;
  scheduleTypeId: number | 0;
  showSaveButton: boolean;
  disableControls: boolean;
  enableControls: boolean;
  enableAddtStreamsGridControls: boolean;
  enableAddtStreamsAddButon: boolean;
  editStatusButton: boolean;
  showNotesPopuplink: boolean;
  disableScWorkOrder: boolean;
  ctrlpermissions: LoadScheduleControlFlags;
}

export interface DeepackPopupInput {
  mode: string;
  fsLoadId: number;
  marketId: string;
}

export interface AddStreamDialogData {
  streamid: number | null;
  genId: number | null;
  customerId: number | null;
  siteId: number | null;
  marketid: number | null;
  haulid: number | null;
  schedType: string;
  fsLoadId: number | 0;
  editStream: number | null;
  editUOM: number | null;
  editquantity: number | null;
  tipfee: number | null;
  fsAddtStreamId: number | 0;
  existingStreamIds: number[];
  editRebateUOM: number | null;
  editRebateQuantity: number | null;
  editRebateValue: number | null;
  isEdit: boolean;
  actualDate: string;
  tons: number | null;
}

export interface AddDepackStreamDialogData {
  generatorId: number;
  sid: string;
  hid: string;
  locName: string,
  actualDate: string,
  fsLoadId: number,
  mode:string,
  streamRecord: DepackStreamGridResponse,
  existingStreams: DepackStreamGridResponse[];
}

export interface FeedStockLoadScheduleDispatchDataResponse {
  id: number;
  fsLoadScheduleId: number;
  type: string;
  selectedType: boolean;
  email: string | null;
  phoneNumber: string | null;
  emailDispatched: boolean | null;
  smsDispatched: boolean | null;
  ctype: number | null;
  bcheckbox: boolean;
}

export interface DispatchInfoDialogData {
  fsLoadScheduleId: number;
  isAd: boolean;
  workOrderNumber: string;
}

export enum DispatchType {
  Customer = 'Customer',
  Hauler = 'Hauler',
  DisposalSite = 'Disposal Site'
}

export interface DeepackListResponse {
  id: number
  siteID: string
  scheduleDate: string
  workOrderNumber: string
  actual_Quantity: number
  schedulingNotes: string
  notesForCustomer: string
  notesForHauler: string
  notesForDisposalSite: string
  internalNotes: string
  generatorId: string
  haulerId: string
  projected_Quantity: number
  feeCategories: string
  status: number
  cancelReasonId: number
  cancelReasonNotes: string
  bol: string
  seal: string
  release: string
  pickUp: string
  truck_Number: string
  trailer_Number: string
  tankerNo: string
  driver: string
  customer: string
  destination: string
  location: string,
  hauler: string
}


export interface SaveDepackFSLSAdditionalStreamsRequest {
  id: number;
  fSLoadID: number | null;
  streamID: number | null;
  streamName: string | null;
  uOM: number | null;
  uOMText: string | null;
  quantity: number | null;
  tipFee: number | null;
  aD_RebateUOM: number | null;
  aD_RebateQty: number | null;
  aD_RebateUOMText: string | null;
  rebateValue: number | null;
  priceMatrixId: number | null;
}

export interface SaveDepackFeedstockLoadScheduleRequest {
  id: number;
  siteID: string | null;
  actualDate: string | null;
  generatorId: string | null;
  hauler: string | null;
  driver: string | null;
  trailer_Number: string | null;
  status: number | null;
  notesForHauler: string | null;
  notesForCustomer: string | null;
  internalNotes: string | null;
  flatFee: number | null;
  feeCategories: string | null;
  customerReferenceNo: string | null;
  holdLoadOnComplete: boolean | null;
  isInvoiceReqForCancelledLoad: boolean | null;
  seal: string | null;
  bol: string | null;
  truck_Number: string | null;
  pickUp: string | null;
  release: string | null;
  fS_LoadSchedule_AdditionalStreams: SaveDepackFSLSAdditionalStreamsRequest[] | null;
  documents: FeedStockLoadAddDocumentRequest | null;
}

export interface DepackFeedstockLoadScheduleWithStreamsByIdResponse{
  data: DepackFeedstockLoadScheduleByIdResponse;
  streams: DeepackOutboundStreamsTableType[];
}

export interface DepackFeedstockLoadScheduleByIdResponse {
  id: number;
  siteId: number;
  sid: string,
  workOrderNumber: string;
  feedstockStreamId: number | null;
  actualDate: string;
  notesForCustomer: string;
  generatorId: number;
  generator: string;
  haulerId: number;
  hid: string,
  hauler: string;
  ticket_Number: string;
  trailer_Number: string;
  driver: string;
  loadSlip: boolean;
  status: number;
  statusDescription: string;
  notesForHauler: string;
  notesForDisposalSite: string;
  flatFee: number;
  internalNotes: string;
  loadSlipNumber: number;
  feeCategories: string;
  customerReferenceNo: string;
  market: number;
  holdLoadOnComplete: boolean;
  tipFee: number | null;
  isInvoiceReqForCancelledLoad: boolean | null;
  seal: string | null;
  bol: string | null;
  truck_Number: string | null;
  pickUp: string | null;
  release: string | null;
  location: string | null;
  priceMatrixId: number | null;
}

export interface DepackStreamGridResponse {
  tempKey?: number;
  id: number; //additional stream id
  fSLoadID: number;
  streamID: number;
  streamName: string;
  uom: number;
  uomText: string;
  quantity: number;
  tipFee: number;
  aD_RebateUOM: number | null;
  aD_RebateUOMText: string | null;
  aD_RebateQty: number | null;
  rebateValue: number | null;
  rebateTotal: number | null
  total: number | null,
  aPriceMatrixId:number|null,
  haulRev: number;
}

export interface GetPriceMatrixForStreamResponse {
  id: number; //price matrixId
  haul_Rate_Perload: number | null;
  tipFee: number | null;
  tipFee_UOM: number | null;
  rebate_UOM: number | null;
  projectedVolume: number | null;
  rebateValue: number | null;
}

export interface SiteWithAddressResponse{
  id: number;
  sid: string | null;
  siteName: string | null;
  address: string | null
}

export interface OutboundInput{
  task: string;
  type: string;
  driverMode: boolean;
  ipData: GetDeepackOutboundResponse | null
}
export interface UserGridColumnPreferenceRequest {
  gridId: number;
  columnsJson: string;
}

export interface UserGridColumnPreferenceResponse {
  userGridColumnPreferenceId: number;
  gridId: number;
  columnsJson: string;
}
